"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("@material-ui/core/Link"));
var Link = function (_a) {
    var classes = _a.classes, component = _a.component, children = _a.children, color = _a.color, TypographyClasses = _a.TypographyClasses, underline = _a.underline, _b = _a.variant, variant = _b === void 0 ? 'inherit' : _b, href = _a.href, onClick = _a.onClick;
    return (react_1.default.createElement(Link_1.default, { classes: classes, component: component, color: color, TypographyClasses: TypographyClasses, underline: underline, variant: variant, href: href, onClick: onClick }, children));
};
exports.default = Link;
